import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { mobileEnter, mobileLeave } from '../state/mobile-actions-creator';
import { Store } from '@ngrx/store';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { MobileState, initialMobileState } from '../state/mobile-state';
import { FlowTrackingService } from '../../../signup/shared/services/flow-tracking.service';
import { IAppState } from '../../../app_state';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({
  selector: 'yi-mobile-message',
  template: require('./mobile_message.component.html'),
  styles: [require('./mobile_message.component.scss')]
})
export class MobileMessageComponent implements OnInit, OnDestroy {

  mobileSate = initialMobileState;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private redcrossService: AnalyticsTrackingProvider,
    private store: Store<IAppState>,
    private toastrService: ToastService,
    private translate: TranslateService,
    private flowTrackingService: FlowTrackingService
  ) {
    this.store.select(state => state.app.install.mobile).subscribe(
      state => {
        this.mobileSate = state as MobileState;
      }
    );
  }

  ngOnInit() {
    this.flowTrackingService.MobilePageStarted(this.activatedRoute.snapshot);
    this.store.dispatch(mobileEnter());
  }

  ngOnDestroy() {
    this.store.dispatch(mobileLeave());
  }

  continue() {
    this.flowTrackingService.MobilePageCompleted(this.activatedRoute.snapshot, 'continue anyway');
    this.store.dispatch(mobileLeave());
    this.router.navigate([this.mobileSate.continueTo]);
  }

  sendMeLink() {
    this.toastrService.success(this.translate.instant('MOBILE.EMAIL_SENT_TO') + ' ' + this.mobileSate.userEmail);
    this.redcrossService.track(REDCRSS_EVENTS.MOBILE_LINK_REQUESTED);
    this.flowTrackingService.MobilePageCompleted(this.activatedRoute.snapshot, 'send link');
  }

}
